/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import GroupDetailHOC from 'ui-permit/shared-components/registration/GroupDetailNew';

const ADDRESS_PATH = 'mailing_address';
const GROUP_DETAIL_PROP_PATH = 'primary_permit_holder';

const GroupDetail = GroupDetailHOC(undefined, {
    GROUP_DETAIL_PROP_PATH,
    GROUP_DETAIL_ADDRESS_PROP_PATH: ADDRESS_PATH,
    GROUP_DETAIL_ADDRESS1_PROP_PATH: 'street[0]',
    GROUP_DETAIL_ADDRESS2_PROP_PATH: 'street[1]',
    GROUP_DETAIL_COUNTRY_PROP_PATH: 'country_code',
});

export default class MailingAddress extends React.Component {
    copyAccountInformation(copyAccountCheck) {
        const { pActions, reservation } = this.props;
        const { id } = reservation;

        if (!copyAccountCheck) {
            const zipCode = get(
                reservation,
                `${GROUP_DETAIL_PROP_PATH}.home_address.postal_code`
            );
            const streetAddress = get(
                reservation,
                `${GROUP_DETAIL_PROP_PATH}.home_address.street[0]`
            );
            const streetAddress2 = get(
                reservation,
                `${GROUP_DETAIL_PROP_PATH}.home_address.street[1]`
            );

            const state = get(
                reservation,
                `${GROUP_DETAIL_PROP_PATH}.home_address.state_code`
            );
            const city = get(reservation, `${GROUP_DETAIL_PROP_PATH}.home_address.city`);
            const country = get(
                reservation,
                `${GROUP_DETAIL_PROP_PATH}.home_address.country_code`
            );

            pActions.updatePendingReservation(
                id,
                `${ADDRESS_PATH}.street[0]`,
                streetAddress
            );
            pActions.updatePendingReservation(
                id,
                `${ADDRESS_PATH}.street[1]`,
                streetAddress2
            );
            pActions.updatePendingReservation(id, `${ADDRESS_PATH}.city`, city);

            pActions.updatePendingReservation(id, `${ADDRESS_PATH}.postal_code`, zipCode);
            pActions.updatePendingReservation(id, `${ADDRESS_PATH}.state_code`, state);
            if (country) {
                pActions.updatePendingReservation(
                    id,
                    `${ADDRESS_PATH}.country_code`,
                    country
                );
            } else {
                pActions.updatePendingReservation(
                    id,
                    `${ADDRESS_PATH}.country_code`,
                    'United States'
                );
            }
        }
        pActions.updatePendingReservation(
            id,
            `${ADDRESS_PATH}.copy_account`,
            !copyAccountCheck
        );
    }

    render() {
        const { reservation } = this.props;
        const copyAccountCheck = get(reservation, `${ADDRESS_PATH}.copy_account`, false);

        return (
            <div className="permit-vehicle-wrap">
                <div className="rec-nested-wrap">
                    <div className="rec-grid-12-12">
                        <GroupDetail
                            isLocationOnly
                            {...this.props}
                            addressTitle="Mailing Address"
                        />
                    </div>
                    <div className="rec-grid-11-12">
                        <div className="rec-form-item-wrap">
                            <label
                                htmlFor="copy-from-above"
                                className="rec-label-checkbox"
                            >
                                <input
                                    id="copy-from-above"
                                    className="rec-input-hide"
                                    type="checkbox"
                                    checked={copyAccountCheck}
                                    onChange={() => {
                                        this.copyAccountInformation(copyAccountCheck);
                                    }}
                                />
                                <span className="rec-input-checkbox" />
                                <strong>Copy information from above</strong>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MailingAddress.propTypes = {
    validation: PropTypes.object.isRequired,
    reservation: PropTypes.object.isRequired,
    pActions: PropTypes.object.isRequired,
    displayValidationError: PropTypes.bool,
    hasPermission: PropTypes.bool,
};

MailingAddress.defaultProps = {
    hasPermission: true,
};

MailingAddress.attributes = {
    requirePermissionCheck: true,
};
